import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, FC } from 'react';
export const ChevronIcon: FC<ComponentProps<'svg'>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path className="fill-current" id="symbol" fillRule="evenodd" clipRule="evenodd" d="M4.26895 8.68233L5.73106 7.31769L12 14.0344L18.269 7.31769L19.7311 8.68232L12 16.9656L4.26895 8.68233Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};